import axios from 'axios';
import { getApiBaseURL, getLoginURL } from './config';

const api = axios.create({
  baseURL: getApiBaseURL(),
  headers: {
    'Content-Type': 'application/json',
  },
});

// 모든 요청에 토큰 자동 첨부
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * 인증을 **요청하는** 엔드포인트.
 *
 * 이 경로의 401 은 "가지고 있던 세션이 만료됐다"가 아니라 "자격 증명이 틀렸다"이다.
 * 전역 리다이렉트를 태우면 `location.href` 대입이 페이지를 리로드해
 * LoginPage 가 통째로 재생성되고, 방금 세팅한 오류 문구가 사라진다.
 * (같은 `/login` URL 이어도 `location.href` 대입은 리로드다.)
 * → 결과: 비밀번호를 틀려도 아무 안내 없이 화면만 깜빡였다.
 *
 * 백엔드에 `admin/login` 계열 라우트는 이 둘뿐이다 (auth.controller.ts:30, :41).
 * 앱 사용자용 `/auth/login` 은 여기에 걸리지 않는다.
 */
const AUTH_REQUEST_ENDPOINTS = ['/admin/login', '/admin/login/verify-totp'];

/** 절대 URL 로 호출되는 경우까지 감안해 경로 끝을 비교한다. */
const isAuthRequest = (url = '') => {
  const path = url.split('?')[0].replace(/\/+$/, '');
  return AUTH_REQUEST_ENDPOINTS.some(
    (endpoint) => path === endpoint || path.endsWith(endpoint),
  );
};

// 401 응답 시 로그인 페이지로 이동 (로그인 요청 자체는 제외 — 위 주석 참고)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !isAuthRequest(error.config?.url)) {
      localStorage.removeItem('token');
      window.location.href = getLoginURL();
    }
    return Promise.reject(error);
  },
);

export default api;
